/**
 * User Stats Cards Component
 * Displays user statistics in cards
 */

import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Users, Crown, Store, Network } from 'lucide-react';

export const UserStatsCards = ({ users, branding }) => {
  const stats = [
    {
      label: 'Total Users',
      value: users.length,
      icon: Users,
      color: branding?.primary_color || '#7c3aed',
      bgColor: `${branding?.primary_color || '#7c3aed'}20`,
    },
    {
      label: 'Admins',
      value: users.filter(u => u.role === 'admin').length,
      icon: Crown,
      color: '#eab308',
      bgColor: 'rgb(234 179 8 / 0.1)',
    },
    {
      label: 'Store Managers',
      value: users.filter(u => u.role === 'store_manager').length,
      icon: Store,
      color: '#3b82f6',
      bgColor: 'rgb(59 130 246 / 0.1)',
    },
    {
      label: 'Org Assigned',
      value: users.filter(u => u.org_entry_id).length,
      icon: Network,
      color: '#22c55e',
      bgColor: 'rgb(34 197 94 / 0.1)',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((stat, idx) => (
        <Card key={idx}>
          <CardContent className="p-4 flex items-center gap-3">
            <div 
              className="p-2 rounded-full" 
              style={{ backgroundColor: stat.bgColor }}
            >
              <stat.icon className="w-5 h-5" style={{ color: stat.color }} />
            </div>
            <div>
              <p className="text-2xl font-bold">{stat.value}</p>
              <p className="text-xs text-muted-foreground">{stat.label}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default UserStatsCards;
